define('drops/calendarDayView/calendarDayView',[
    'jquery',
    'underscore',
    'luxon',
    'lq/constants',
    'globalize',
    'lq/drop',
    'drops/calendar/calendarParameter',
    'drops/calendar/calendarItems',
    'lq/nestingContext',
    'lq/multiSourceValue',
    'tpl!drops/calendarDayView/calendarDayView.html',
    'lq/onlongpress'
], function ($, _, luxon, constants, globalize, Drop, calendarParameter, calendarItems, NestingContext, multiSourceValue, template, OnLongPress) {
    'use strict';

    const { DateTime } = luxon;

    var defaults = {
        data: {
            dataSource: null,
            dataSourceType: 'datetimes',
            dateOutput: null,
            startOutput: null,
            endOutput: null,
            calendarStartParameter: 'CalendarDayStart',
            calendarEndParameter: 'CalendarDayEnd',
            timeslotSize: 30,
            dayStart: 0,
            dayEnd: (60 * 24) - 1,
            titleFormat: 'D',
            timeslotHourFormat: 'HH:mm',
            longPressDelay: 1000
        },
        childDrops: [
            {
                data: { type: 'CalendarItem' }
            }
        ]
    };

    function CalendarDayView(options) {
        Drop.call(this, $(template()), defaults, options);
        // right now we're not really doing anything with the selected date in the day view
        this.selectedDate = null;
    };

    Drop.extend(CalendarDayView, Drop);

    CalendarDayView.typeName = 'CalendarDayView';

    CalendarDayView.prototype.applyPosition = $.noop;

    CalendarDayView.prototype.init = function () {
        this.nestingContext = new NestingContext(this.piping);

        multiSourceValue.initialize(
            this,
            this.data.scrollPosition,
            this.goToScrollToPosition.bind(this));
    };

    CalendarDayView.prototype.goToScrollToPosition = function (scrollPosition) {
        if (this.isValidISOFormat(scrollPosition)) {
            scrollPosition = this.getMinutesFromMidnight(scrollPosition);
        }

        if (!$.isNumeric(scrollPosition)) {
            return;
        }
        
        var slotNumber = Math.floor((scrollPosition - this.data.dayStart) / this.data.timeslotSize);
        var $slot = this.$hours.children('.timeslot').eq(slotNumber);
        this.$container.scrollTop(this.$container.scrollTop() + $slot.position().top);
    };

    CalendarDayView.prototype.getMinutesFromMidnight = function (dateString) {
        var date = new Date(dateString);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var totalMinutes = hours * 60 + minutes;

        return totalMinutes;
    };

    CalendarDayView.prototype.isValidISOFormat = function (input) {
        if (typeof input !== "string") {
            return false;
        }
        return DateTime.fromISO(input).isValid;
    };

    CalendarDayView.prototype.loadCalendarData = function () {
        if (!this.data.dataSource)
            return;

        var dateOfRequestedData = this.date;

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.date))
                    self.showItems(response.outputs, response.results);
            });

        if (!this.data.activeTSDataSource)
            return;

        this.piping.queryDispatcher.backgroundDispatch(
            this.data.activeTSDataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.date))
                    self.setActiveTimeslots(response.results);
            });
    };

    CalendarDayView.prototype.setSelectedDate = function (date) {
        this.selectedDate = date;
    };

    CalendarDayView.prototype.clearSelectedDate = function () {
        this.selectedDate = null;
    };

    CalendarDayView.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    CalendarDayView.prototype.render = function () {
        this.registerForDataSource();
        this.prepareUi();
        this.createTimeslots();
        this.open(DateTime.now());
    };

    CalendarDayView.prototype.prepareUi = function () {
        this.$container = this.$element.find('.calendar-main');
        this.$title = this.$element.find('.date-as-title');
        this.$hours = this.$element.find('.hours');
        this.$timeslots = this.$element.find('.timeslots');

        this.$element.find('.previous-page')
            .on('click', this.previous.bind(this));
        this.$element.find('.next-page')
            .on('click', this.next.bind(this));
    };

    CalendarDayView.prototype.createTimeslots = function () {
        var timeslots = _.range(this.data.dayStart, this.data.dayEnd, this.data.timeslotSize);

        var self = this;
        var $hours = _.map(timeslots, function (slot) {
            var date = new Date(1970, 0, 1);
            date.setMinutes(slot);

            return $('<div />')
                .addClass('timeslot')
                .append($('<span />')
                    .text(globalize.format(date, self.data.timeslotHourFormat)));
        });
        this.$hours.append($hours);

        var $timeslots = _.map(timeslots, function (startMinute) {
            var $timeslot = $('<div />')
                .addClass('timeslot')
                .data('time', startMinute);

            new OnLongPress().applyLongPressOnElement($timeslot, self,
                function(e) {
                    return self.determineEventArg(startMinute);
                }, function () {
                    self.timeslotClicked(startMinute);
                });

            $timeslot.on("mousedown", calendarItems.timeslotMousedown.bind(self, self.$timeslots, 0));
            $timeslot.on("mouseup", calendarItems.timeslotMouseup.bind(self));
            $timeslot.on("mousemove", calendarItems.timeslotMousemove.bind(self));

            return $timeslot;
        });

        this.$timeslots.append(
            $('<div class="calendar-item-container"/>')
        );

        this.$timeslots.append($timeslots);
    };

    var round = function (x, roundTo) {
        return Math.round(x / roundTo) * roundTo;
    };

    var getMouseEventMinutes = function (e, data) {
        var timeslotIndex = $(e.target).index();
        var y = e.offsetY;
        var yTot = timeslotIndex * data.timeslotSize + y;

        var creationInterval = data.creationInterval || data.timeslotSize; // creationInterval editable in property editor?
        return round(yTot, creationInterval);
    };

    CalendarDayView.prototype.determineEventArg = function (startMinute) {
        var dateAndTime = this.date
            .startOf('day')
            .plus({ minutes: startMinute });
        return globalize.format(dateAndTime.toJSDate(), constants.licquidDateFormat);
    };

    CalendarDayView.prototype.timeslotClicked = function (startMinute) {
        var eventArg = this.determineEventArg(startMinute);
        this.triggerEvent(this.data.eventing.clicked.raisedEventName, eventArg);
    };

    CalendarDayView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data, _isUpdate) {
                self.removeCalendarItems();
                self.showItems(data.outputs, data.results);
            });
        }

        if (this.data.activeTSDataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.activeTSDataSource, function (data, _isUpdate) {
                self.setActiveTimeslots(data.results);
            });
        }
    };

    CalendarDayView.prototype.previous = function () {
        this.open(this.date.minus({ days: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarDayView.prototype.next = function () {
        this.open(this.date.plus({ days: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarDayView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.date);
    };

    CalendarDayView.prototype.open = function (date) {
        this.date = date;
        this.updateTitle();
        this.removeCalendarItems();

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, calendarParameter.convert(this.date.startOf('day')));
        parameters.locals.setValue(this.data.calendarEndParameter, calendarParameter.convert(this.date.endOf('day')));
    };

    CalendarDayView.prototype.getOpenDate = function () {
        return this.date;
    };

    CalendarDayView.prototype.updateTitle = function () {
        var title = globalize.format(this.date.toJSDate(), this.data.titleFormat);
        this.$title.text(title);
    };

    CalendarDayView.prototype.splitDateRangeAtMidnight = function(startOfItem, endOfItem) {
        var items = [];
        var currentStart = startOfItem;

        while (currentStart.startOf('day') < endOfItem.startOf('day')) {
            var currentEnd = currentStart.endOf('day');

            items.push({
                start: currentStart,
                end: currentEnd
            });

            currentStart = currentStart.plus({ days: 1 }).startOf('day');
        }

        // Add the final segment (from midnight to the end)
        items.push({
            start: currentStart,
            end: endOfItem
        });

        return items;
    };

    CalendarDayView.prototype.showItems = function (outputs, rows) {
        var startOfDay = this.date.startOf('day').plus({ minutes: this.data.dayStart });
        var endOfDay = this.date.startOf('day').plus({ minutes: this.data.dayEnd });

        var self = this;
        var items = [];

        _.each(rows, function (row) {
            var startOfItem = self.getDatetimeFromRow(row, self.data.startOutput);
            var endOfItem = self.getDatetimeFromRow(row, self.data.endOutput);

            // If the timespan would span multiple days, split it at midnight
            var splitItems = self.splitDateRangeAtMidnight(startOfItem, endOfItem);

            _.each(splitItems, function (splitItem) {
                items.push($.extend(true, {}, self.childDrops[0],{
                    data: {
                        $target: self.$timeslots.find('.calendar-item-container'),
                        startOfDay: startOfDay,
                        endOfDay: endOfDay,
                        startOfItem: splitItem.start,
                        endOfItem: splitItem.end,
                        row: row,
                        outputs: outputs,
                        eventArg: self.data.eventArg,
                        tooltipOutput: self.data.tooltipOutput,
                        idOutput: self.data.idOutput
                    }
                }));
            });
        });

        calendarItems.fillUp(this, items)
            .then(function () {
                self.nestingContext.executeDataSources();
            }).catch(function (e) {
                self.piping.errorHandler.showErrorDialog(e);
            });
    };

    CalendarDayView.prototype.removeCalendarItems = function () {
        _.each(this.pool, function (drop) {
            drop.$element.remove();
        });
        this.removeAllDrops();
        this.data.calendarItemGroups = [];
    };

    CalendarDayView.prototype.getDatetimeFromRow = function (row, output) {
        if (this.data.dataSourceType === 'datetimes')
            return DateTime.fromISO(row[output]);

        var date = this.date.startOf('day');
        var time = row[output];
        return date.plus({ seconds: time });
    };

    CalendarDayView.prototype.setActiveTimeslots = function (rows) {
        var self = this;

        var $timeslots = self.$timeslots.children();
        var $activeTimeslots = $(); 

        rows.forEach(function (row) {
                var activeTSStart = self.getDatetimeFromRow(row, self.data.activeTSStartOutput).toJSDate();
                var activeTSEnd = self.getDatetimeFromRow(row, self.data.activeTSEndOutput).toJSDate();

                var $filteredTimeslots = $timeslots.filter(function () {
                    var time = $(this).data('time');

                    return time >= self.getTimeOfDay(activeTSStart) && time < self.getTimeOfDay(activeTSEnd);
                });

                $activeTimeslots.push(...$filteredTimeslots);
            });

        $activeTimeslots.addClass('active-timeslot');
        $timeslots.not($activeTimeslots).removeClass('active-timeslot');
    };

    CalendarDayView.prototype.getTimeOfDay = function (date) {
        return date.getHours() * 60 + date.getMinutes();
    };

    return CalendarDayView;
});
